import { ButtonProps, IconButtonProps, TextProps } from "@chakra-ui/react";
import {
  BannerCarousel,
  BannerCarouselItemProps,
  BannerCarouselProps,
} from "@picovico/ui";

import { useGetBannersQuery } from "@store/services/misc";
import { useRouter } from "next/router";
import { useMemo } from "react";
import { useAppSelector } from "store";

export function HomeBannerCarousel({
  buyButtonProps,
  playIconProps,
  buyButtonTextProps,
  playIconTextProps,
  ...props
}: Pick<
  BannerCarouselProps,
  | "showNavigation"
  | "showPagination"
  | "swiperConfig"
  | "bannerWrapperProps"
  | "variant"
  | "bannerBoxProps"
  | "imageProps"
> & {
  buyButtonProps?: ButtonProps;
  playIconProps?: IconButtonProps;
  buyButtonTextProps?: TextProps;
  playIconTextProps?: TextProps;
}) {
  const { company_idx } = useAppSelector((state) => state.config);
  const { cinema_hall } = useAppSelector((state) => state.activeCinemaHall);
  const { isLoading, data } = useGetBannersQuery({
    company_idx: company_idx,
    cinema_hall: cinema_hall,
  });
  const router = useRouter();

  const bannerItems = useMemo(() => {
    const movieBanners: BannerCarouselItemProps[] =
      data?.data?.banner_movies?.map((movieBannerItem) => ({
        show_idx: movieBannerItem.idx,
        bannerImg: movieBannerItem.banner,
        showBannerAction: movieBannerItem.has_show,
        showBuyButton: movieBannerItem.has_show,
        grade: movieBannerItem.grade || "PG",
        trailer: movieBannerItem.trailer,
        genre: movieBannerItem.genre,
        description: movieBannerItem.description,
        bannerTitle: movieBannerItem.name,
        release_date: movieBannerItem.release_date,
        buyButtonProps,
        playIconProps,
        buyButtonTextProps,
        playIconTextProps,
        onBuyClick: () => {
          router.push(`/movie/${movieBannerItem.idx}/${cinema_hall}`);
        },
      })) || [];
    const promotionalBanners: BannerCarouselItemProps[] =
      data?.data?.promotional_banner?.map((promotionalItem) => {
        return {
          bannerImg: promotionalItem.image,
          bannerTitle: promotionalItem.title,
          showBannerAction: false,
        };
      }) || [];

    return promotionalBanners.concat(movieBanners);
  }, [
    data,
    cinema_hall,
    router,
    buyButtonProps,
    playIconProps,
    buyButtonTextProps,
    playIconTextProps,
  ]);

  return (
    <>{!isLoading && <BannerCarousel {...props} bannerItems={bannerItems} />}</>
  );
}
